import React from 'react';
import { generatePath } from 'react-router-dom';
import { congratulationIcon } from '@/assets/images';
import RouterLink from '@/components/common/RouterLink';
import EntityContentType from '@/constants/EntityContentType';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import translate from '@/lib/intl/translate';
import type Campaign from '@/types/api/Campaign';
import { formatCurrency } from '@/utils/currency';
import getEntitySource from '../lib/getEntitySource';
import { type CampaignContentType } from '../types/entityDetails';

function Congratulations() {
  return (
    <img className="mb-[3px] inline h-4 w-4" alt="" src={congratulationIcon} />
  );
}

export type CampaignSummaryProps = {
  entityType: CampaignContentType;
  entity: Campaign;
};

export default function CampaignSummary({
  entity,
  entityType,
}: CampaignSummaryProps) {
  const {
    displayName,
    goals: [{ stretchAmount = 0 } = {}],
  } = entity;
  let congratulationsIcons;

  if (entityType === EntityContentType.CAMPAIGN_GOAL_MET) {
    congratulationsIcons = (
      <>
        <Congratulations />
        <Congratulations />
        <Congratulations />
      </>
    );
  }

  return translate(`CAMPAIGN_DETAILS_${entityType.toUpperCase()}`, {
    displayName,
    'link-to-campaign': () => (
      <RouterLink
        to={generatePath(AuthRoutes.CAMPAIGN, {
          campaignId: entity.campaignId,
        })}
      >
        {displayName}
      </RouterLink>
    ),
    ...getEntitySource(entity),
    ...(congratulationsIcons && { congratulationsIcons }),
    ...(stretchAmount && { amount: formatCurrency(stretchAmount, true) }),
  });
}
